<!-- <p>panel-header works!</p> -->
<div class="header">
    <div class="button-div alignRow">
        <!-- <span *ngIf="customTimeRange"><b>
                {{numDays <= 1 ? (numDays * 24).toFixed(0) : numDays}} {{numDays <=1 ? "Hours" : "Days" }}</b> </span> -->
        <span *ngIf="customTimeRange"><b>
                {{getCustomTimeRangeText()}}</b> </span>
        <mat-icon *ngIf="!dashboardFullscreen && document && document.fullscreenElement" class="more-button"
            (click)="exitFullscreen()">fullscreen_exit</mat-icon>
        <mat-icon class="more-button" [matMenuTriggerFor]="buttonMenu">more_horiz</mat-icon>
    </div>
</div>

<mat-menu #buttonMenu yPosition="below" xPosition="before">
    <button *ngIf="document && !document.fullscreenElement" mat-menu-item (click)="fullscreenPanel()">
        <mat-icon>fullscreen</mat-icon><span>Fullscreen Panel</span>
    </button>
    <button *ngIf="!dashboardFullscreen && document && document.fullscreenElement" mat-menu-item
        (click)="exitFullscreen()">
        <mat-icon>fullscreen_exit</mat-icon><span>Exit Fullscreen</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="timeMenu" #trigger="matMenuTrigger">
        <mat-icon>access_time</mat-icon><span>Time Period</span>
    </button>
</mat-menu>

<mat-menu #timeMenu>
    <div style="margin: 1em; z-index: 9999;">
        <span>Date Range:</span>
        <app-date-range-picker (datePickerChange)="datePickerChange($event)"
            [matMenuTrigger]="trigger"></app-date-range-picker>
        <br><br>
        <span>Duration:</span>
        <app-duration-selector [(duration)]="strDuration"
            (durationChange)="durationChange($event)"></app-duration-selector>
        <button mat-raised-button (click)="resetTimePeriod()">
            <span>Reset</span>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</mat-menu>